import { apiClient } from '@/api/client';
import { downloadResponseAsFile } from '@/lib/utils';

/**
 * Download the job card .xlsx for a job.
 *
 * Returns any non-fatal warning the backend sent (degraded hours calculation, or
 * workers past the sheet's 6-row capacity). It rides on a response header, so it
 * MUST be read before the body is consumed by the download — and the header must
 * stay listed in the backend's CORS exposeHeaders or it vanishes in production.
 */
export async function downloadJobCardXlsx(params: {
  jobId: string;
  jobCode: string;
  documentId?: string;
}): Promise<{ warning: string | null }> {
  const { jobId, jobCode, documentId } = params;
  const response = await apiClient.post<Response>('/job-cards', { jobId, documentId });
  const warning = response.headers.get('X-Job-Card-Warning');
  await downloadResponseAsFile(response, `JobCard_${jobCode}.xlsx`);
  return { warning: warning ? decodeURIComponent(warning) : null };
}
